import React, { useState } from 'react';
import CustomButton from '../customButton';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { loginFormValidation } from '../../helpers/formValidators/loginFormValidator';
import loginUser from '../../helpers/apiActions/login';
import Loader from '../loader';
import CustomAlert from '../customAlert';



export function LoginForm() {

    const {
        register,
        handleSubmit,
        formState: { errors },
      } = useForm({
        resolver: yupResolver(loginFormValidation),
      });

      const [loading, setisLoading] = useState(false);

      const [alertData, setAlertData] = useState({
          show: false,
          message: '',
          isError: false,
      });

      const redirectUser = () => {
          window.location.href='/home';
      }

      const handleAlertClose = () => {
          setAlertData({show:false, message:'', isError:false});
      }

    const onSubmit = async(data, e) => {
        (e).preventDefault();
        setisLoading(true);
        try{
            const response = await loginUser(data);
            if(!response.ok) {
                setAlertData({
                    show: true,
                    message: `Her gikk det galt!`,
                    isError: true,
                });
            } if(response.status === 200) {
                setAlertData({
                    show:true,
                    message:'Velkommen! Du er nå logget inn!',
                    isError: false,
                });
            }
        }catch(error){
            console.log(error)
        }
        setisLoading(false);
    }


      return (
          <div className="login-card mt-5 col-8 col-md-4 m-auto pt-1">
              <p className="mt-5 logg-inn-overskrift">LOGG INN</p>
              <div>
                  {loading && <Loader />}
              </div>
              
              <div className="d-flex flex-column justify-content-center align-items-center">
                <form className="mt-5" onSubmit={handleSubmit(onSubmit)}>
                  <input
                    className="input-button text-primary"
                    placeholder="E-mail"
                    {...register('identifier')}
                  />
                  <p>{errors.identifier?.message}</p>
                  <input
                    className="input-button text-primary"
                    placeholder="Passord"
                    type="password"
                    {...register('password')}
                  />
                  
                  <p>{errors.password?.message}</p>
                  <CustomButton 
                    className="mt-3 col-10 col-md-7 m-auto login-button text-white" 
                    label="LOGG INN" 
                    onClick={handleSubmit(onSubmit)}
                    />
                </form>
                <div className="mb-5">
                    <CustomAlert
                        show={alertData.show}
                        handleClose={handleAlertClose}
                        message={alertData.message}
                        isError={alertData.isError}
                        redirectUser={redirectUser}
                        buttonLabel="Jeg forstår!"
                        buttonClassName="login-button text-white"
                    />
                </div>
              </div>
          </div>
        
      );
    }
    
export default LoginForm;